<template>
  <div
    class="text-left px-0"
    id="appointments"
    style="background-color: #0e0e0e !important; min-height: 100vh"
  >
    <div class="schedule-bg">
      <div class="container p-0 position-relative" style="top: 60%">
        <div class="d-flex justify-content-between align-items-center px-3 px-md-0">
          <div class="font-md-32 font-20 kallisto-bold mb-0 text-left" id="pod-schedule">
            Pod Schedule
          </div>
          <!-- Mobile Location selector -->
          <MobileLocationSelector @location-changed="onMobileLocationChanged" />
        </div>
        <hr class="d-md-none schedule-divider" />
      </div>
    </div>
    <div class="container px-0">
      <div class="d-flex justify-content-start align-items-center pt-32 pl-16">
        <p class="font-14 os-semibold text-gold m-0 mobile-seats-label">
          Total available seats for today:
        </p>
        <p
          class="ml-14 mb-0 text-white font-14 mobile-seats-count"
          style="border-radius: 6px; color: white; background: #ffffff1a"
        >
          {{ getTotalSeats(availableFilteredSessions).available }}
          of
          {{ getTotalSeats(availableFilteredSessions).total }}
        </p>
      </div>
      <div class="row d-none d-md-block mt-36 mb-32">
        <div class="col-12 d-flex justify-content-between py-0">
          <div class="col-6 p-0 d-flex align-items-center">
            <DateNavigator @dateChanged="handleDateChanged" />
          </div>
          <div class="col-6 p-0 d-flex align-items-center justify-content-end">
            <template v-if="$store.state.SchedulerSessions.length > 0">
              <div class="dropdown-wrapper">
                <button
                  type="button"
                  id="subjectDropdown"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  class="position-relative d-inline-block d-flex justify-content-center align-items-center moduleAct-corses mr-12"
                >
                  <span class="font-weight-bold text-black mb-0 font-12 font-md-14">
                    {{ selectedSubject || 'All courses' }}
                  </span>
                  <img
                    class="my-auto pl-2"
                    src="@/assets/icons/down-chevron.svg"
                    alt="down-chevron"
                  />
                </button>

                <div class="dropdown-menu dropdown-options" aria-labelledby="subjectDropdown">
                  <div class="d-flex flex-column templateOptionsBackground">
                    <button
                      class="dropdown-item text-white pl-20 font-md-14 os-semibold"
                      @click="selectOption('All courses')"
                    >
                      All courses
                    </button>
                    <button
                      v-for="(tlc, i) in showOptions"
                      :key="i"
                      class="dropdown-item text-white pl-20 font-md-14 os-semibold"
                      @click="selectOption(tlc)"
                    >
                      {{ tlc }}
                    </button>
                  </div>
                </div>
              </div>

              <template
                v-if="
                  $store.state.SchedulerSessions.length > 0 &&
                  ['admin', 'pod operator', 'instructor'].includes($store.state.role)
                "
              >
                <button
                  class="filter-button-mobile font-14 font-weight-bold pt-8 pb-8"
                  @click="openDesktopFilter"
                  style="width: 95px; height: 38px"
                >
                  <img :src="getIcon('funnel-mobile.svg')" alt="funnel-mobile" class="pr-1" />
                  Filters
                </button>

                <!-- Desktop Filter Modal -->
                <div
                  id="desktopFilterModal"
                  class="modal fade p-0 text-light"
                  tabindex="-1"
                  role="dialog"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-md modal-dialog-centered" role="document">
                    <div
                      class="modal-content"
                      style="
                        border: 0.5px solid #0b5786 !important;
                        box-shadow: 0px 3px 14px 0px rgba(184, 236, 255, 0.15);
                        border-radius: 12px;
                        min-width: 520px !important;
                      "
                    >
                      <div class="b-modal-header h-100 d-flex flex-column justify-content-between">
                        <div class="d-block">
                          <div
                            class="d-flex justify-content-between align-items-center py-3 px-4"
                            style="border-bottom: 0.5px solid #555555"
                          >
                            <p
                              class="d-flex filter-header-mobile kallisto-bold justify-content-center flex-grow-1 mb-0"
                              style="color: #d0d0d0 !important"
                            >
                              Select filters
                            </p>
                            <a data-bs-dismiss="modal" style="display: flex; height: 30px">
                              <img
                                alt="x-button-mobile"
                                class="pointer x-button"
                                height="12"
                                :src="getIcon('x-button.svg')"
                              />
                            </a>
                          </div>
                          <div class="mt-24 pb-3 px-4">
                            <!-- Pod Filter -->
                            <div class="filter-section mb-3">
                              <div class="filter-header pb-3 text-light">
                                Pod ({{ selectedFilteredPods.length }})
                              </div>
                              <div class="d-flex flex-wrap py-1">
                                <div
                                  v-for="(pod, po) in getPods($store.state.SchedulerSessions)"
                                  :key="po"
                                  class="col-6 p-0 mb-2"
                                >
                                  <label class="check-container text-light">
                                    <input
                                      :id="getPods($store.state.SchedulerSessions)[po]"
                                      type="checkbox"
                                      :checked="
                                        selectedFilteredPods.includes(
                                          getPods($store.state.SchedulerSessions)[po]
                                        )
                                      "
                                      @change="
                                        updatePods(getPods($store.state.SchedulerSessions)[po])
                                      "
                                    />
                                    <span class="checkmark-mobile"></span>
                                    <span class="pt-6 d-block">
                                      Pod {{ getPod(getPods($store.state.SchedulerSessions)[po]) }}
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>

                            <!-- Shows Filter -->
                            <div class="filter-section mb-3">
                              <div class="filter-header py-3 text-light">
                                Shows ({{ selectedFilteredActs.length }})
                              </div>
                              <div class="d-flex flex-wrap py-1">
                                <div
                                  v-for="(mod, mo) in getModules($store.state.SchedulerSessions)"
                                  :key="mo"
                                  class="col-6 p-0 mb-2"
                                >
                                  <label class="check-container text-light">
                                    <input
                                      :id="getModules($store.state.SchedulerSessions)[mo]"
                                      type="checkbox"
                                      :checked="
                                        selectedFilteredActs.includes(
                                          getModules($store.state.SchedulerSessions)[mo]
                                        )
                                      "
                                      @change="
                                        updateModule(getModules($store.state.SchedulerSessions)[mo])
                                      "
                                    />
                                    <span class="checkmark-mobile"></span>
                                    {{
                                      getTitleData(getModules($store.state.SchedulerSessions)[mo])
                                        .shortname
                                    }}
                                  </label>
                                </div>
                              </div>
                            </div>

                            <!-- Show Type Filter -->
                            <div class="filter-section mb-3">
                              <div class="filter-header py-3 text-light">
                                Show type ({{ getActiveAudienceCount() }})
                              </div>
                              <div class="py-1 d-flex">
                                <p class="mr-100">
                                  <label class="check-container text-light">
                                    <input v-model="filterHiddenShows" type="checkbox" />
                                    <span class="checkmark-mobile"></span>
                                    Hidden shows
                                  </label>
                                </p>
                                <p class="mb-3">
                                  <label class="check-container text-light">
                                    <input v-model="filterPublicShow" type="checkbox" />
                                    <span class="checkmark-mobile"></span>
                                    Public shows
                                  </label>
                                </p>
                              </div>
                            </div>

                            <!-- Reservation Type Filter -->
                            <div class="filter-section">
                              <div class="filter-header py-3 text-light">
                                Reservation type ({{ getActiveReservationCount() }})
                              </div>
                              <div class="py-1 d-flex">
                                <p class="mr-150">
                                  <label class="check-container text-light">
                                    <input v-model="filterTypeGroup" type="checkbox" />
                                    <span class="checkmark-mobile"></span>
                                    Group
                                  </label>
                                </p>
                                <p class="mb-3">
                                  <label class="check-container text-light">
                                    <input v-model="filterTypeIndividual" type="checkbox" />
                                    <span class="checkmark-mobile"></span>
                                    Individual
                                  </label>
                                </p>
                              </div>
                            </div>

                            <!-- Footer Buttons -->
                            <div class="d-flex justify-content-center pb-32 pt-3">
                              <div class="d-flex gap-3">
                                <button
                                  class="text-center font-weight-bold font-14 reset-button-filter px-4"
                                  @click="clearAllFilters"
                                >
                                  Reset Filters
                                </button>
                                <button
                                  class="text-center font-weight-bold font-14 apply-filter-button-mobile px-4"
                                  data-bs-dismiss="modal"
                                  @click="applyFilters"
                                >
                                  Apply ({{
                                    selectedFilteredPods.length +
                                    selectedFilteredActs.length +
                                    getActiveAudienceCount() +
                                    getActiveReservationCount()
                                  }})
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>

      <div class="d-none d-md-block">
        <div v-if="hasNoSessionsForToday" class="no-sessions p-4 font-24">
          <p class="py-4">No sessions are scheduled</p>
        </div>
        <div
          v-else-if="availableFilteredSessions.length == 0 && hasActiveFilters"
          class="no-sessions p-4 font-24"
        >
          <p class="py-4">No results matching your filters</p>
          <button
            class="text-center font-weight-bold font-14 clear-all-filters-button px-4 py-2"
            @click="clearAndApplyAllFilters"
          >
            Clear all filters
          </button>
        </div>
        <div
          v-else-if="availableFilteredSessions.length == 0 && !hasCrossSystemEventsToday"
          class="no-sessions p-4 font-24"
        >
          <p class="py-4">There are currently no sessions available for the day</p>
        </div>
        <template v-else-if="$store.state.appointmentsRefresh">
          <div v-for="(session, s) in availableFilteredSessions" :key="s">
            <div
              class="border-layout mb-22 mt-12"
              v-if="compareSessionDateWithPodSessionDate(session.start_timestamp)"
            >
              <div class="session-header-wrap">
                <button
                  class="accordion-heading-button-desktop text-left align-items-center w-100"
                  :id="'dropdownSession' + s"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#collapseSession' + s"
                  aria-expanded="false"
                  :aria-controls="'collapseSession' + s"
                  style="background-color: #242424; border: none"
                >
                  <div class="d-flex justify-content-between">
                    <div class="col-md-5 col-lg-5 col-12 p-0">
                      <div class="d-flex">
                        <div class="p-0 col-12" style="max-width: fit-content">
                          <h3 class="font-24 d-inline font-weight-bold">
                            {{ getTitleData(session.title_id).shortname }}
                            <img
                              v-if="session.group_session"
                              :src="getIcon('group.svg')"
                              alt="group"
                              class="ml-2"
                            />
                          </h3>
                        </div>
                        <span class="mt-1">
                          <p
                            v-if="isLabOrRecitation(session)"
                            style="
                              display: flex;
                              width: 85px;

                              border-radius: 12px;
                              background: rgba(255, 255, 255, 0.1);
                              justify-content: center;
                              padding: 5px 10px;
                              line-height: 1;
                              font-size: 14px;
                              margin-bottom: 0px;
                            "
                          >
                            {{ (getTagType(session) || []).join(', ') }}
                          </p>
                        </span>
                      </div>
                      <div class="d-flex" style="margin-top: 5px">
                        <div
                          class="font-16 font-weight-bold d-flex"
                          style="color: #d0d0d0; width: 100%; flex-direction: row"
                        >
                          <img
                            :src="getIcon('clock-regular-appointment-mobile.svg')"
                            alt="clock-regular-appointment-mobile"
                            class="mr-2 mb-1"
                            style="width: 12px"
                          />
                          {{ getTrimTime(session.start_timestamp) }}

                          <div class="d-flex p-0 m-0" v-if="isLabOrRecitation(session)">
                            &nbsp; | &nbsp;
                            {{ (getSectionId(session) || []).join(', ') }}
                          </div>
                          <div v-if="session.pod_id" class="d-flex">
                            &nbsp; | &nbsp;
                            <div>Pod &nbsp;</div>
                            <div class="pod-num">
                              {{ getPod(session.pod_id) }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex mt-10">
                        <span
                          v-if="session.show_time_description == 'public show'"
                          class="font-12 font-weight-bold btn-white p-1 px-2 mr-12"
                          style="border: 1px solid #007dc5; border-radius: 4px"
                        >
                          Public
                        </span>
                        <span
                          v-else-if="session.show_time_description == 'hidden show'"
                          class="font-12 font-weight-bold btn-white p-1 px-2"
                          style="border: 1px solid #ffc627; border-radius: 4px"
                        >
                          Private
                        </span>
                        <span v-else class="font-12 font-weight-bold btn-white p-1 px-2">
                          {{ session.show_time_description }}
                        </span>
                        <a
                          class="table-header font-14 os-semibold"
                          style="
                            border-radius: 6px;
                            text-decoration: none;
                            padding: 5px 12px;
                            margin: 0x 12px;
                          "
                        >
                          {{ session.seats_available }} of {{ session.max_seats }} seats left
                        </a>
                      </div>
                    </div>
                    <div class="d-flex justify-content-end p-0">
                      <div
                        class="d-flex justify-content-center align-items-center"
                        style="
                          background: #2a2a2a;
                          width: 30px;
                          height: 30px;
                          border-radius: 50%;
                          margin-top: 4px;
                        "
                      >
                        <img
                          :src="getIcon('accordion-down-arrow.svg')"
                          alt="accordion-down-arrow"
                          class="rotate-icon"
                          style="width: fit-content"
                        />
                      </div>
                    </div>
                  </div>
                </button>

                <!-- Session actions: overlaid on the header rather than nested inside the
                     accordion toggle above, which would be a button inside a button and
                     would collapse the row every time the menu was opened. -->
                <cancel-session
                  v-if="
                    !$store.state.loader &&
                    ($store.state.role == 'admin' || $store.state.role == 'pod operator')
                  "
                  class="session-actions"
                  :session="session"
                />

                <!-- Collapsible Content -->
                <div
                  :id="'collapseSession' + s"
                  class="collapse"
                  :aria-labelledby="'dropdownSession' + s"
                  style="background-color: #151515"
                >
                  <div class="py-0 px-0" style="border-top: 1px solid #4e4222">
                    <div class="font-14 mb-1 tableScroll">
                      <table class="col-12 mb-0">
                        <tr class="table-header d-flex pl-3">
                          <th class="col-3 py-md-2 p-0 px-md-4">Name</th>
                          <th class="col-lg-3 col-5 py-md-2 p-0">Email</th>
                          <th class="col-2 py-md-2 p-0">User Type</th>
                          <th class="col-2 py-md-2 p-0">Status</th>
                          <th
                            class="col-2 py-md-2 p-0"
                            v-if="
                              $store.state.role == 'admin' || $store.state.role == 'pod operator'
                            "
                          >
                            Cancel
                          </th>
                        </tr>
                        <participants
                          v-if="!$store.state.loader"
                          :session="session"
                          :key="session"
                        />
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- Cross-system occupancy events (desktop) -->
        <template
          v-if="
            getCrossSystemEventsForDate($store.state.crossSystemEvents, $store.state.podSessionDate)
              .length > 0
          "
        >
          <div
            v-for="(csEvent, csIdx) in getCrossSystemEventsForDate(
              $store.state.crossSystemEvents,
              $store.state.podSessionDate
            )"
            :key="'cs-desktop-' + csIdx"
            class="cross-system-card border-layout mb-22 mt-12"
          >
            <div
              class="cross-system-card-inner px-4 py-3"
              style="
                height: 156px;
                padding: 32px 32px 26px 32px !important;
                background-color: #242424;
              "
            >
              <h3 class="font-24 d-inline font-weight-bold mb-1">
                {{ getCrossSystemTitle(csEvent) }}
              </h3>
              <div class="d-flex align-items-center mt-1" style="color: #d0d0d0; font-size: 14px">
                <img
                  :src="getIcon('clock-regular-appointment-mobile.svg')"
                  alt="time"
                  class="mr-2"
                  style="width: 12px"
                />
                {{ formatCrossSystemTime(csEvent) }}
              </div>
              <p class="mb-0 mt-1" style="color: #888888; font-size: 13px">
                Occupied by Custom Portal
              </p>
            </div>
          </div>
        </template>
      </div>

      <!-- Below for mobile view -->
      <div class="mb-3 d-block d-md-none px-3">
        <!-- Date row: calendar icon + date carousel -->
        <div class="d-flex align-items-center mt-3 mb-3 mobile-date-row">
          <div class="d-flex align-items-center">
            <DateNavigator @dateChanged="handleDateChanged" />
          </div>
          <div class="d-flex align-items-center flex-grow-1 ml-2">
            <Carousel
              v-if="currentWeek && currentWeek.length > 0"
              :items-to-show="4"
              :mouse-drag="true"
              :snap-align="'start'"
              style="width: 100% !important"
            >
              <Slide
                v-for="day in currentWeek"
                :key="day"
                style="flex-basis: auto !important; width: auto; padding: 0% 2% !important"
              >
                <div>
                  <button
                    class="button-carousel-mobile"
                    :class="[
                      isToday(day) && isDaySelected(day)
                        ? 'selected-button-carousel-mobile'
                        : isToday(day)
                          ? 'today-button-carousel-mobile'
                          : isDaySelected(day)
                            ? 'selected-button-carousel-mobile'
                            : '',
                    ]"
                    @click="setCurrentDate(day)"
                  >
                    <span class="month-carousel-mobile d-block text-uppercase">
                      {{ day.toLocaleString('default', { month: 'short' }) }}
                    </span>
                    <span class="date-carousel-mobile d-block">
                      {{ day.toLocaleString('default', { day: '2-digit' }).substr(0, 2) }}
                    </span>
                    <span class="month-carousel-mobile d-block text-uppercase">
                      {{ day.toLocaleString('default', { weekday: 'short' }) }}
                    </span>
                  </button>
                </div>
              </Slide>
            </Carousel>
          </div>
        </div>

        <!-- Filters + Course dropdown row -->
        <div class="d-flex justify-content-between align-items-center" style="margin-bottom: 32px">
          <div class="d-flex align-items-center">
            <button
              v-if="
                $store.state.SchedulerSessions.length > 0 &&
                ['admin', 'pod operator', 'instructor'].includes($store.state.role)
              "
              class="filter-button-mobile font-14 font-weight-bold d-flex align-items-center justify-content-center"
              @click="openMobileFilter"
            >
              <img :src="getIcon('funnel-mobile.svg')" alt="funnel-mobile" class="pr-1" />
              Filters
            </button>
          </div>
          <div v-if="$store.state.SchedulerSessions.length > 0" class="dropdown">
            <button
              type="button"
              id="mobileSubjectDropdown"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              class="position-relative d-inline-flex align-items-center moduleAct-corses dropdown-toggle-no-caret"
            >
              <span class="font-weight-bold text-black mb-0 font-12">
                {{ selectedSubject || 'All courses' }}
              </span>
              <img
                class="my-auto pl-2"
                src="@/assets/icons/down-chevron.svg"
                alt="down-chevron"
                style="pointer-events: none"
              />
            </button>
            <ul class="dropdown-menu dropdown-options" aria-labelledby="mobileSubjectDropdown">
              <li>
                <a
                  class="dropdown-item text-white pl-20 font-14 os-semibold"
                  href="#"
                  @click.prevent="selectOption('All courses')"
                >
                  All courses
                </a>
              </li>
              <li v-for="(tlc, i) in showOptions" :key="i">
                <a
                  class="dropdown-item text-white pl-20 font-14 os-semibold"
                  href="#"
                  @click.prevent="selectOption(tlc)"
                >
                  {{ tlc }}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <!-- Mobile Filter Modal -->
        <div
          id="mobileFilterModal"
          class="modal fade p-0 text-light"
          tabindex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal-dialog-slideout modal-md"
            role="document"
            style="margin: 0 auto 0 0 !important; width: 320px !important"
          >
            <div class="modal-content mobile-filter-content">
              <div class="d-flex flex-column h-100">
                <!-- Header -->
                <div class="d-flex justify-content-between px-3 py-3 flex-shrink-0">
                  <span class="d-flex filter-header-mobile kallisto-bold text-light">
                    Select filters
                  </span>
                  <a data-bs-dismiss="modal" class="text-right">
                    <img class="pointer" :src="getIcon('x-button.svg')" alt="x-button-mobile" />
                  </a>
                </div>

                <!-- Scrollable filter sections -->
                <div class="flex-grow-1 overflow-auto mt-24">
                  <!-- Shows Filter Section -->
                  <div class="mobile-filter-section mb-3">
                    <div
                      class="mobile-filter-header px-3 py-2 d-flex justify-content-between"
                      @click="toggleShowFilterCollapseMobile"
                    >
                      <span class="text-light">Shows</span>
                      <img
                        class="filter-chevron"
                        :class="{ 'filter-chevron--open': !isShowFilterCollapsedMobile }"
                        :src="getIcon('accordion-down-arrow.svg')"
                        alt="filter-collapse"
                      />
                    </div>
                    <div v-if="!isShowFilterCollapsedMobile" class="py-1 px-3">
                      <p
                        v-for="(mod, mo) in getModules($store.state.SchedulerSessions)"
                        :key="mo"
                        class="mb-0"
                      >
                        <label class="check-container text-light">
                          <input
                            :id="mod"
                            type="checkbox"
                            :checked="selectedFilteredActs.includes(mod)"
                            @change="updateModule(mod)"
                          />
                          <span class="checkmark-mobile"></span>
                          {{ getTitleData(mod).shortname }}
                        </label>
                      </p>
                    </div>
                  </div>

                  <!-- Pod Filter Section -->
                  <div class="mobile-filter-section mb-3">
                    <div
                      class="mobile-filter-header px-3 py-2 d-flex justify-content-between"
                      @click="togglePodFilterCollapseMobile"
                    >
                      <span class="text-light">Pod</span>
                      <img
                        class="filter-chevron"
                        :class="{ 'filter-chevron--open': !isPodFilterCollapsedMobile }"
                        :src="getIcon('accordion-down-arrow.svg')"
                        alt="filter-collapse"
                      />
                    </div>
                    <div v-if="!isPodFilterCollapsedMobile" class="py-1 px-3">
                      <p
                        v-for="(pod, po) in getPods($store.state.SchedulerSessions)"
                        :key="po"
                        class="mb-0"
                      >
                        <label class="check-container text-light">
                          <input
                            :id="pod"
                            type="checkbox"
                            :checked="selectedFilteredPods.includes(pod)"
                            @change="updatePods(pod)"
                          />
                          <span class="checkmark-mobile"></span>
                          <span>Pod {{ getPod(pod) }}</span>
                        </label>
                      </p>
                    </div>
                  </div>

                  <!-- Show Type Filter Section -->
                  <div class="mobile-filter-section mb-3">
                    <div
                      class="mobile-filter-header px-3 py-2 d-flex justify-content-between"
                      @click="toggleAudienceFilterCollapseMobile"
                    >
                      <span class="text-light">Show type</span>
                      <img
                        class="filter-chevron"
                        :class="{ 'filter-chevron--open': !isAudienceFilterCollapsedMobile }"
                        :src="getIcon('accordion-down-arrow.svg')"
                        alt="filter-collapse"
                      />
                    </div>
                    <div v-if="!isAudienceFilterCollapsedMobile" class="py-1 px-3">
                      <p class="mb-0">
                        <label class="check-container text-light">
                          <input v-model="filterPublicShow" type="checkbox" />
                          <span class="checkmark-mobile"></span>
                          Public show
                        </label>
                      </p>
                      <p class="mb-0">
                        <label class="check-container text-light">
                          <input v-model="filterHiddenShows" type="checkbox" />
                          <span class="checkmark-mobile"></span>
                          Private show
                        </label>
                      </p>
                    </div>
                  </div>

                  <!-- Reservation Type Filter Section -->
                  <div class="mobile-filter-section mb-3">
                    <div
                      class="mobile-filter-header px-3 py-2 d-flex justify-content-between"
                      @click="
                        isReservationFilterCollapsedMobile = !isReservationFilterCollapsedMobile
                      "
                    >
                      <span class="text-light">Reservation type</span>
                      <img
                        class="filter-chevron"
                        :class="{ 'filter-chevron--open': !isReservationFilterCollapsedMobile }"
                        :src="getIcon('accordion-down-arrow.svg')"
                        alt="filter-collapse"
                      />
                    </div>
                    <div v-if="!isReservationFilterCollapsedMobile" class="py-1 px-3">
                      <p class="mb-0">
                        <label class="check-container text-light">
                          <input v-model="filterTypeIndividual" type="checkbox" />
                          <span class="checkmark-mobile"></span>
                          Individual
                        </label>
                      </p>
                      <p class="mb-0">
                        <label class="check-container text-light">
                          <input v-model="filterTypeGroup" type="checkbox" />
                          <span class="checkmark-mobile"></span>
                          Group
                        </label>
                      </p>
                    </div>
                  </div>
                </div>

                <!-- Footer Buttons (pinned to bottom) -->
                <div class="d-flex justify-content-center px-3 py-3 flex-shrink-0">
                  <div class="d-flex gap-2 w-100">
                    <button
                      class="text-center font-weight-bold font-14 clear-filter-button-mobile px-3 flex-grow-1"
                      @click="clearAllFilters"
                    >
                      Reset filters
                    </button>
                    <button
                      class="text-center font-weight-bold font-14 apply-filter-button-mobile px-3 flex-grow-1"
                      data-bs-dismiss="modal"
                      @click="applyFilters"
                    >
                      Apply ({{
                        selectedFilteredPods.length +
                        selectedFilteredActs.length +
                        getActiveAudienceCount() +
                        getActiveReservationCount()
                      }})
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="hasNoSessionsForToday" class="no-sessions p-4 font-24">
          <p class="py-4">No sessions are scheduled</p>
        </div>

        <div
          v-else-if="availableFilteredSessions.length == 0 && hasActiveFilters"
          class="no-sessions p-4 font-24"
        >
          <p class="py-4">No results matching your filters</p>
          <button
            class="text-center font-weight-bold font-14 clear-all-filters-button px-4 py-2"
            @click="clearAndApplyAllFilters"
          >
            Clear all filters
          </button>
        </div>
        <div
          v-else-if="availableFilteredSessions.length == 0 && !hasCrossSystemEventsToday"
          class="no-sessions p-4 font-24"
        >
          <p class="py-4">There are currently no sessions available for the day</p>
        </div>
        <div id="accordion-mobile" class="accordion" v-else-if="$store.state.appointmentsRefresh">
          <div
            v-for="(pod, po) in getPods(availableFilteredSessions)"
            :key="po"
            class="accordion-item"
            style="background-color: #151515 !important; border: none !important"
          >
            <h5
              class="accordion-header mb-0"
              :id="'headingOne' + po"
              style="border-bottom: 1px solid #132732 !important; border-radius: 0% !important"
            >
              <button
                class="accordion-heading-button text-left px-3 py-2 align-items-center collapsed"
                type="button"
                data-bs-toggle="collapse"
                :data-bs-target="'#collapseOne' + po"
                aria-expanded="false"
                :aria-controls="'collapseOne' + po"
              >
                <span class="font-weight-bold font-14">Pod {{ getPod(pod) }}</span>
                <span class="accicon">
                  <img
                    :src="getIcon('accordion-down-arrow.svg')"
                    alt="accordion-down-arrow"
                    class="rotate-icon mr-3"
                  />
                </span>
              </button>
            </h5>

            <div
              :id="'collapseOne' + po"
              class="accordion-collapse collapse"
              :aria-labelledby="'headingOne' + po"
              data-bs-parent="#accordion-mobile"
            >
              <div class="card-body p-0" style="background: #242424">
                <div v-for="(session, s) in availableFilteredSessions" :key="s">
                  <div v-if="compareSessionDateWithPodSessionDate(session.start_timestamp)">
                    <div
                      v-if="session.pod_id === pod"
                      style="
                        border-bottom: 1px solid #d0d0d040 !important;
                        border-radius: 0% !important;
                      "
                    >
                      <div style="width: 100%">
                        <button
                          class="collapse-user-details-header d-flex justify-content-between px-3 pt-3 pb-20"
                          type="button"
                          @click="toggleCollapsedUserDetails(session.pod_id, session.session_id)"
                          data-bs-toggle="collapse"
                          :data-bs-target="'#collapse-user-details-mobile' + s"
                          aria-expanded="false"
                          :aria-controls="'collapse-user-details-mobile' + s"
                        >
                          <div class="m-0 text-left">
                            <p class="font-weight-bold font-16 m-0">
                              {{ getTitleData(session.title_id).shortname }}
                            </p>
                            <p class="m-0 text-left d-flex align-items-center mt-1">
                              <span
                                v-if="session.show_time_description == 'public show'"
                                class="font-12 font-weight-bold btn-white px-2 justify-content-center d-flex"
                                style="width: 52px; padding: 3px"
                              >
                                Public
                              </span>
                              <span
                                v-else-if="session.show_time_description == 'hidden show'"
                                class="font-12 font-weight-bold btn-gold px-2 justify-content-center d-flex"
                                style="width: 52px; padding: 3px"
                              >
                                Private
                              </span>
                              <span
                                v-else
                                class="font-12 font-weight-bold btn-white px-2 justify-content-center d-flex"
                                style="width: 52px; padding: 3px"
                              >
                                {{ session.show_time_description }}
                              </span>
                              <img
                                :src="getIcon('clock-regular-appointment-mobile.svg')"
                                alt="clock-regular-appointment-mobile"
                                class="ml-10"
                              />
                              <span
                                class="font-weight-bold font-12 pl-1"
                                style="color: #d0d0d0 !important"
                              >
                                {{ getTrimTime(session.start_timestamp) }}
                              </span>
                            </p>
                            <p class="m-0 text-left mt-10">
                              <a
                                class="table-header font-12 font-weight-bold"
                                style="border-radius: 4px; text-decoration: none; padding: 4px 10px"
                              >
                                {{ session.seats_available }} of {{ session.max_seats }} seats left
                              </a>
                            </p>
                          </div>
                          <div class="mr-3">
                            <img
                              :src="getCollapsedUserDetails(session.pod_id, session.session_id)"
                              alt="collapse-plus"
                              class="collapse-icons"
                            />
                          </div>
                        </button>
                      </div>
                      <div class="collapse" :id="'collapse-user-details-mobile' + s">
                        <div class="" style="background-color: #151515 !important">
                          <participants v-if="!$store.state.loader" :session="session" />
                        </div>
                        <div
                          style="width: 100% !important; background-color: #242424 !important"
                          class="d-flex justify-content-center align-items-center"
                        >
                          <cancel-session
                            v-if="
                              !$store.state.loader &&
                              ($store.state.role == 'admin' || $store.state.role == 'pod operator')
                            "
                            :session="session"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="px-4">No sessions are scheduled</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Cross-system occupancy events (mobile) -->
          <template
            v-if="
              getCrossSystemEventsForDate(
                $store.state.crossSystemEvents,
                $store.state.podSessionDate
              ).length > 0
            "
          >
            <div
              v-for="(csEvent, csIdx) in getCrossSystemEventsForDate(
                $store.state.crossSystemEvents,
                $store.state.podSessionDate
              )"
              :key="'cs-mobile-' + csIdx"
              class="cross-system-card mt-2 mx-1"
            >
              <div
                class="cross-system-card-inner px-3 pt-3 pb-20"
                style="background-color: #242424"
              >
                <h3 class="font-18 font-weight-bold mb-1">
                  {{ getCrossSystemTitle(csEvent) }}
                </h3>
                <div class="d-flex align-items-center mt-1" style="color: #d0d0d0; font-size: 14px">
                  <img
                    :src="getIcon('clock-regular-appointment-mobile.svg')"
                    alt="time"
                    class="mr-2"
                    style="width: 12px"
                  />
                  {{ formatCrossSystemTime(csEvent) }}
                </div>
                <p class="mb-0 mt-1" style="color: #888888; font-size: 13px">
                  Occupied by Custom Portal
                </p>
              </div>
            </div>
          </template>

          <div
            class="modal fade px-0"
            id="import-shows"
            data-backdrop="exampleModalLabel"
            data-keyboard="false"
            tabindex="-1"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered modal-lg mx-0 mx-md-auto">
              <div class="modal-content animate-bottom">
                <div class="p-0 modal-body p-5" style="min-height: 400px">
                  <div class="d-flex justify-content-between">
                    <h2 class="font-weight-bold"><a>Import shows</a></h2>
                    <button data-bs-dismiss="modal" style="border: none" class="p-2"></button>
                  </div>
                  <div class="mt-4 pt-3 text-center">
                    <label class="mt-4" v-if="showfileupload">
                      <input
                        id="fileUpload"
                        accept=".csv"
                        type="file"
                        ref="inputFile"
                        @input="setUploadFile()"
                        style="display: none"
                      />
                      <img
                        class="p-2"
                        :src="getIcon('download-solid-white.svg')"
                        alt="check-solid"
                      />
                      <a
                        class="cursor-pointer font-24 text-lightt font-weight-bold mb-2"
                        style="text-decoration: underline"
                      >
                        Click here to Upload a file
                      </a>
                      <p class="font-14 text-muted mb-0">Supported file type: CSV</p>

                      <div class="d-flex justify-content-center mt-2 pt-5">
                        <button
                          class="mx-2 py-2 px-4"
                          data-bs-dismiss="modal"
                          style="border: 1px solid"
                        >
                          Cancel
                        </button>
                        <button class="mx-2 py-2 px-4 btn-disabled">
                          <a>Import</a>
                        </button>
                      </div>
                    </label>
                    <div v-else>
                      <div
                        class="p-3"
                        v-if="
                          fileStatus && fileStatus.inValidData && fileStatus.inValidData.length > 0
                        "
                      >
                        <a class="font-weight-bold font-24">Error:</a>
                        <p
                          class="font-20 font-weight-bold"
                          v-for="(errorMsg, em) in fileStatus.inValidData"
                          :key="em"
                        >
                          {{ errorMsg.message }}
                        </p>
                        <label class="mt-4">
                          <input
                            id="fileUpload"
                            accept=".csv"
                            type="file"
                            ref="inputFile"
                            @input="setUploadFile()"
                            style="display: none"
                          />
                          <a class="cursor-pointer">Upload a new file again</a>
                          <div class="d-flex justify-content-center mt-1 pt-5">
                            <button
                              class="mx-2 py-2 px-4"
                              data-bs-dismiss="modal"
                              style="border: 1px solid"
                            >
                              Cancel
                            </button>
                            <button class="mx-2 py-2 px-4 btn-disabled">
                              <a>Import</a>
                            </button>
                          </div>
                        </label>
                      </div>
                      <!-- Import Error State -->
                      <div v-else-if="importError" class="p-3 text-center">
                        <p class="font-24 font-weight-bold">Import failed</p>
                        <p class="font-18">{{ importError }}</p>
                        <div class="d-flex justify-content-center mt-1 pt-5">
                          <button
                            class="mx-2 py-2 px-4"
                            data-bs-dismiss="modal"
                            style="border: 1px solid"
                            @click="importError = ''"
                          >
                            Close
                          </button>
                          <button
                            class="mx-2 py-2 px-4"
                            @click="
                              importError = '';
                              showfileupload = true;
                            "
                          >
                            Try again
                          </button>
                        </div>
                      </div>
                      <div v-else class="text-center">
                        <div v-if="index > 0" class="my-2 font-20">
                          <p class="font-24 font-weight-bold">Importing shows...</p>
                          <p class="font-18">{{ index }} of {{ fileStatus.data.length }}</p>
                        </div>
                        <p class="font-24" v-else>Your file was successfully validated!</p>
                        <div class="d-flex justify-content-center mt-1 pt-5">
                          <button
                            class="mx-2 py-2 px-4"
                            data-bs-dismiss="modal"
                            style="border: 1px solid"
                          >
                            Cancel
                          </button>
                          <button
                            class="mx-2 py-2 px-4"
                            v-if="importEnabled"
                            @click="importShows(fileStatus.data)"
                          >
                            <a>Import</a>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';
import { API } from '@/utils/amplifyCompat';
import getExpierence from '../mixins/getSessionMixin';
import participants from './participants';
import cancelSession from './cancelSession.vue';
import moment from 'moment';
import DateNavigator from './DatePicker/DateNavigator.vue';
import CSVFileValidator from 'csv-file-validator';
import { Carousel, Slide } from '@/plugins/vue-carousel';
import MobileLocationSelector from './base/MobileLocationSelector.vue';
import { mapGetters } from 'vuex';
import { useCrossSystemOccupancy } from '@/components/scheduler/composables/useCrossSystemOccupancy';

export default {
  components: {
    participants,
    cancelSession,
    DateNavigator,
    Carousel,
    Slide,
    MobileLocationSelector,
  },
  mixins: [getExpierence],
  data() {
    return {
      availableFilteredSessions: [],

      showOptions: [],
      publicSHows: false,
      hiddenShows: false,
      filterHiddenShows: false,
      filterPublicShow: false,
      typeGroup: false,
      typeIndividual: false,
      filterTypeGroup: false,
      filterTypeIndividual: false,
      selectedPods: [],
      selectedFilteredPods: [],
      selectedActs: [],
      selectedFilteredActs: [],
      showfileupload: true,
      importEnabled: false,
      fileStatus: null,
      disabledDates: {
        to: new Date(Date.now() - 8640000),
        days: [6, 0], // Disable Saturday's and Sunday's
      },
      sessionid: '',
      calendarDate: null,
      openCancelBtn: false,
      refresh: true,
      listActPods: [],
      index: 0,
      importError: '',
      isMouseDragging: false,
      isPodFilterCollapsedMobile: false,
      isShowFilterCollapsedMobile: false,
      isAudienceFilterCollapsedMobile: false,
      isReservationFilterCollapsedMobile: false,
      clearFiltersBackup: {
        isPublicShows: true,
        isHiddenShows: true,
        unselectedPods: [],
        unseletecActs: [],
      },
      isCollapsedUserDetails: [],
      subjectOptions: [],
      selectedSubject: 'All courses', // here subjects
      tlcTitleMapping: null,
    };
  },
  computed: {
    ...mapGetters({
      getSchedulerSessions: 'getSchedulerSessions',
    }),
    currentWeek() {
      return this.getCurrentWeek();
    },
    hasCrossSystemEventsToday() {
      return (
        this.getCrossSystemEventsForDate(
          this.$store.state.crossSystemEvents,
          this.$store.state.podSessionDate
        ).length > 0
      );
    },
    hasNoSessionsForToday() {
      return this.$store.state.SchedulerSessions.length === 0 && !this.hasCrossSystemEventsToday;
    },
    hasActiveFilters() {
      return (
        this.selectedPods.length > 0 ||
        this.selectedActs.length > 0 ||
        this.hiddenShows ||
        this.publicSHows ||
        this.typeGroup ||
        this.typeIndividual ||
        this.selectedSubject !== 'All courses'
      );
    },
  },
  watch: {
    getSchedulerSessions: {
      immediate: true,
      handler(newSessions) {
        this.availableFilteredSessions = newSessions;
        this.$nextTick(() => {
          this.filterSessions();
        });
      },
    },
  },
  async mounted() {
    await this.$store.dispatch('setTitles');

    // Fetch sessions for the correct active site on mount, same pattern as Calendar.vue.
    // Without this, the page shows stale data from a previous fetch (possibly wrong site).
    if (!this.$store.state.allSites?.length) {
      await this.$store.dispatch('setAllSites');
    }
    const activeSiteId =
      this.$store.state.selectedSiteForScheduler?.site_id || this.$store.state.selected_site_id;
    // Default podSessionDate to today if not set — it's not persisted and starts as ''.
    if (!this.$store.state.podSessionDate) {
      this.$store.state.podSessionDate = moment().format('YYYY-MM-DD');
    }
    const myData = {
      selected_site_id: activeSiteId,
      podSessionDate: this.$store.state.podSessionDate,
    };
    this.$store.state.loader = true;
    await this.$store.dispatch('setSchedulerSessions', myData).finally(() => {
      this.$store.state.loader = false;
    });

    // Fetch cross-system occupancy after sessions are done
    const mountDate = this.$store.state.podSessionDate || moment().format('YYYY-MM-DD');
    this.loadCrossSystemDay(this.$store, mountDate);

    // Arrow scroll handler
    const arrowEl = document.getElementById('arrow-left-solid');
    if (arrowEl) {
      arrowEl.addEventListener('click', () => {
        const targetEl = document.querySelector('.add-user-btn');
        if (targetEl) {
          window.scrollTo({
            top: targetEl.offsetTop - 200,
            behavior: 'smooth',
          });
        }
      });
    }

    // Import shows modal event listener
    const importShowsEl = document.getElementById('import-shows');
    if (importShowsEl) {
      importShowsEl.addEventListener('hide.bs.modal', () => {
        this.showfileupload = true;
        this.importEnabled = false;
        this.fileStatus = null;
        this.index = 0;
        this.importError = '';
      });
    }

    this.showOptions = this.subjectOption();
  },
  methods: {
    // Cross-system occupancy helpers
    ...useCrossSystemOccupancy(),

    // Helper methods to handle tag_data as array of objects with tag_type
    getTagData(session) {
      // tag_data is now an array of objects with tag_type attribute
      if (Array.isArray(session.tag_data) && session.tag_data.length > 0) {
        return session.tag_data;
      }
      // Fallback for old format (object) for backward compatibility
      if (session.tag_data && typeof session.tag_data === 'object') {
        return [session.tag_data];
      }
      return [];
    },
    isLabOrRecitation(session) {
      const tagData = this.getTagData(session);
      return tagData.some((tag) => {
        // New format
        if (tag.tag_type === 'lab' || tag.tag_type === 'recitation') {
          return true;
        }
        // Old format fallback
        return tag.is_lab === true || tag.is_recitation === true;
      });
    },
    getTagType(session) {
      const tagData = this.getTagData(session);
      const types = [
        ...new Set(
          tagData
            .map((tag) => {
              if (tag.tag_type === 'lab' || tag.is_lab === true) return 'Lab';
              if (tag.tag_type === 'recitation' || tag.is_recitation === true) return 'Recitation';
              return null;
            })
            .filter(Boolean)
        ),
      ];
      return types.length ? types : null;
    },
    getSectionId(session) {
      const tagData = this.getTagData(session);
      const sectionIds = [...new Set(tagData.map((tag) => tag.section_id).filter(Boolean))];
      return sectionIds.length ? sectionIds : null;
    },
    openDesktopFilter() {
      // Backup current filter values
      this.selectedFilteredPods = [...this.selectedPods];
      this.selectedFilteredActs = [...this.selectedActs];
      this.filterHiddenShows = this.hiddenShows;
      this.filterPublicShow = this.publicShows;
      this.filterTypeIndividual = this.typeIndividual;
      this.filterTypeGroup = this.typeGroup;

      // Open Bootstrap modal
      const modalEl = document.getElementById('desktopFilterModal');
      if (modalEl && window.bootstrap) {
        const modal = Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    },
    openMobileFilter() {
      // Backup current filter values
      this.clearFiltersBackup.isPublicShows = this.publicSHows;
      this.clearFiltersBackup.isHiddenShows = this.hiddenShows;
      this.clearFiltersBackup.unselectedPods = [...this.selectedPods];
      this.clearFiltersBackup.unseletecActs = [...this.selectedActs];

      // Open Bootstrap modal
      const modalEl = document.getElementById('mobileFilterModal');
      if (modalEl && window.bootstrap) {
        const modal = Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
    },
    applyFilters() {
      this.selectedPods = [...this.selectedFilteredPods];
      this.selectedActs = [...this.selectedFilteredActs];
      this.hiddenShows = this.filterHiddenShows;
      this.publicShows = this.filterPublicShow;
      this.typeIndividual = this.filterTypeIndividual;
      this.typeGroup = this.filterTypeGroup;

      this.filterSessions();
    },
    subjectOption() {
      const options = this.$store.state.titles.map((i) => i.tlc);
      return [...new Set(options)];
    },
    onMobileLocationChanged(location) {
      this.$store.state.loader = true;
      this.$store.state.appointmentsRefresh = false;
      const myData = {
        selected_site_id: location.site_id,
        podSessionDate: this.$store.state.podSessionDate,
      };
      this.$store
        .dispatch('setSchedulerSessions', myData)
        .then(() => {
          this.$store.state.loader = false;
          this.$store.state.appointmentsRefresh = true;
          this.availableFilteredSessions = this.$store.state.SchedulerSessions;
          this.showOptions = this.subjectOption();
        })
        .catch(() => {
          this.$store.state.loader = false;
          this.$store.state.appointmentsRefresh = true;
        });

      // Re-fetch cross-system occupancy for the new location + current date
      this.loadCrossSystemDay(this.$store, myData.podSessionDate, location.site_id);
    },
    selectOption(option) {
      this.selectedSubject = option;
      this.tlcMapping();
      this.applyFilters();
      this.RF();
    },
    selectSubject(subject) {
      this.selectedSubject = subject;
      this.arrowUp = false;
      this.onChangeSubject();
    },
    onChangeSubject() {
      this.tlcMapping();
      this.RF();
    },
    tlcMapping(reset = false) {
      if (reset || !this.tlcTitleMapping) {
        this.tlcTitleMapping = {};
      }
      this.$store.state.titles.map((i) => {
        if (!this.tlcTitleMapping[i.tlc]) this.tlcTitleMapping[i.tlc] = new Set();
        this.tlcTitleMapping[i.tlc].add(i.title_id);
      });
      return this.tlcTitleMapping;
    },
    tlcOptions() {
      const options = this.$store.state.titles.map((i) => i.tlc);
      return [...new Set(options)];
    },

    start_and_end(str) {
      if (str.length > 20) {
        return str.substr(0, 9) + '...' + str.substr(str.length - 5, str.length);
      }
      return str;
    },
    getCurrentDate() {
      return {
        dates: [
          // your date
          new Date(Date.now()),
        ],
      };
    },
    getActPods(dump) {
      let podTitles = [];
      dump.forEach((element) => {
        let tempObj = {
          gearup_id: element.gearups[0].gearup_id,
          pod_id: element.pod_id,
          capacity: element.max_users,
          titlesIds: [],
        };
        if (element.titles && element.titles.length > 0) {
          element.titles.forEach((title) => {
            tempObj.titlesIds.push(title.title_id);
          });
        }
        podTitles.push(tempObj);
      });
      this.listActPods = podTitles;
    },
    setUploadFile() {
      this.getActPods(this.$store.state.scheduler_pods[0].pods);
      this.showfileupload = false;
      this.importEnabled = false;
      this.fileStatus = null;
      const file = this.$refs.inputFile.files[0];
      if (file.type == 'text/csv') {
        this.validateCSV(file);
        // Api call
      } else {
        alert('error', "The file-type doesn't belong to text/csv");
      }
    },
    isTitleIdValidate(title_id, row) {
      let status = false;
      let vm = this;
      if (title_id && row[6]) {
        vm.listActPods.forEach((pod) => {
          if (pod.gearup_id == row[6]) {
            if (pod.titlesIds.includes(title_id)) {
              status = true;
            } else {
              return false;
            }
          }
        });
      }
      return status;
    },
    isDateValid(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateString.match(regEx)) return false; // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0, 10) === dateString;
    },
    isCapacityValidate(capacity, row) {
      let status = false;
      let vm = this;
      if (capacity && row[5]) {
        vm.listActPods.forEach((pod) => {
          if (pod.gearup_id == row[6]) {
            if (pod.capacity >= capacity) {
              status = true;
            } else {
              return false;
            }
          }
        });
      }
      return status;
    },
    validateCSV(file) {
      let vm = this;
      const config = {
        headers: [
          {
            name: 'PodNo',
            inputName: 'PodNo',
            required: true,
            requiredError: function (PodNo, rowNumber, columnNumber) {
              return `${PodNo} is required in the ${rowNumber} row / ${columnNumber} column`;
            },
          },
          {
            name: 'title_id',
            inputName: 'title_id',
            required: true,
            requiredError: function (title_id, rowNumber, columnNumber) {
              return `${title_id} is required in the ${rowNumber} row / ${columnNumber} column`;
            },
            dependentValidate: function (title_id, row) {
              return vm.isTitleIdValidate(title_id, row);
            },
            validateError: function (title_id, rowNumber, columnNumber) {
              return `Title id is not valid in the ${rowNumber} row / ${columnNumber} column`;
            },
          },
          {
            name: 'available',
            inputName: 'available',
            required: true,
            requiredError: function (available, rowNumber, columnNumber) {
              return `${available} is required in the ${rowNumber} row / ${columnNumber} column`;
            },
          },
          {
            name: 'schedule_date',
            inputName: 'schedule_date',
            required: true,
            requiredError: function (schedule_date, rowNumber, columnNumber) {
              return `${schedule_date} is required in the ${rowNumber} row / ${columnNumber} column`;
            },
            validate: function (schedule_date) {
              return vm.isDateValid(schedule_date);
            },
            validateError: function (schedule_date, rowNumber, columnNumber) {
              return `${schedule_date} is not in valid format the ${rowNumber} row / ${columnNumber} column expected in YYYY-MM-DD`;
            },
          },
          {
            name: 'local_time',
            inputName: 'local_time',
            required: true,
            requiredError: function (local_time, rowNumber, columnNumber) {
              return `${local_time} is required in the ${rowNumber} row / ${columnNumber} column`;
            },
          },
          {
            name: 'capacity',
            inputName: 'capacity',
            required: true,
            requiredError: function (capacity, rowNumber, columnNumber) {
              return `${capacity} is required in the ${rowNumber} row / ${columnNumber} column`;
            },
            dependentValidate: function (capacity, row) {
              return vm.isCapacityValidate(capacity, row);
            },
            validateError: function (capacity, rowNumber, columnNumber) {
              return `Capacity is not valid in the ${rowNumber} row / ${columnNumber} column`;
            },
          },
          {
            name: 'gearup_id',
            inputName: 'gearup_id',
            required: true,
            requiredError: function (gearup_id, rowNumber, columnNumber) {
              return `${gearup_id} is required in the ${rowNumber} row / ${columnNumber} column`;
            },
          },
          {
            name: 'site_id',
            inputName: 'site_id',
            required: true,
            requiredError: function (site_id, rowNumber, columnNumber) {
              return `${site_id} is required in the ${rowNumber} row / ${columnNumber} column`;
            },
          },
          {
            name: 'reservation_type',
            inputName: 'reservation_type',
            required: false,
          },
          {
            name: 'lab_section_ids',
            inputName: 'lab_section_ids',
            required: false,
          },
          {
            name: 'lecture_section_ids',
            inputName: 'lecture_section_ids',
            required: false,
          },
          {
            name: 'recitation_section_ids',
            inputName: 'recitation_section_ids',
            required: false,
          },
        ],
        parserConfig: {
          beforeFirstChunk: function (chunk) {
            const lines = chunk.split('\n');
            const expectedColumns = config.headers.length;
            const paddedLines = lines.map((line) => {
              if (!line.trim()) return line;
              const fieldCount = line.split(',').length;
              if (fieldCount < expectedColumns) {
                return line + ','.repeat(expectedColumns - fieldCount);
              }
              return line;
            });
            return paddedLines.join('\n');
          },
        },
      };
      let now = this;
      CSVFileValidator(file, config)
        .then((csvStatus) => {
          now.fileStatus = csvStatus;
          if (csvStatus && csvStatus.inValidData && csvStatus.inValidData.length == 0) {
            now.importEnabled = true;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    reccursive(session) {
      let body;
      try {
        body = {
          site_id: session.site_id,
          title_id: session.title_id,
          schedule_date: session.schedule_date,
          local_time: parseInt(session.local_time?.replace(':', '') || '0'),
          public: session.available === 'public' ? true : false,
          gearup_id: session.gearup_id,
          capacity: parseInt(session.capacity),
          reservation_type: session.reservation_type || null,
          tag_data: session.tag_data || [],
          lab_section_ids: session.lab_section_ids || null,
          lecture_section_ids: session.lecture_section_ids || null,
          recitation_section_ids: session.recitation_section_ids || null,
        };
      } catch (conversionError) {
        console.error('=== CSV DATA CONVERSION ERROR ===');
        console.error('Error:', conversionError);
        console.error('Session data that failed:', session);
        return;
      }
      API.put('asulink', `/scheduler/sessions`, { body })
        .then(() => {
          if (this.fileStatus.data.length - 1 > this.index) {
            this.reccursive(this.fileStatus.data[this.index + 1]);
            this.index++;
          } else {
            this.$store.state.loader = false;
            const importModalEl = document.getElementById('import-shows');
            if (importModalEl) {
              const modal = Modal.getOrCreateInstance(importModalEl);
              modal.hide();
            }
            const successModalEl = document.getElementById('import-sucess');
            if (successModalEl) {
              const modal = Modal.getOrCreateInstance(successModalEl);
              modal.show();
            }
          }
        })
        .catch((err) => {
          console.error('Import API error:', err);
          this.$store.state.loader = false;
          const message = err?.response?.data?.message || err?.message || '';
          this.importError = message
            ? `Failed to import shows: ${message}`
            : 'Failed to import shows. Please check the CSV data and try again.';
        });
    },
    async importShows(sessions) {
      this.$store.state.loader = false;
      this.reccursive(sessions[0]);
    },
    updateModule(value) {
      if (this.selectedFilteredActs.includes(value)) {
        this.selectedFilteredActs = this.selectedFilteredActs.filter((e) => e !== value);
      } else {
        this.selectedFilteredActs.push(value);
      }
      // this.RF();
    },
    updatePods(value) {
      if (this.selectedFilteredPods.includes(value)) {
        this.selectedFilteredPods = this.selectedFilteredPods.filter((e) => e !== value);
      } else {
        this.selectedFilteredPods.push(value);
      }
      // this.RF();
    },
    getActiveAudienceCount() {
      let count = 0;
      if (this.filterPublicShow) count++;
      if (this.filterHiddenShows) count++;
      return count;
    },
    getActiveReservationCount() {
      let count = 0;
      if (this.filterTypeGroup) count++;
      if (this.filterTypeIndividual) count++;
      return count;
    },
    clearAllFilters() {
      this.selectedFilteredActs = [];
      this.selectedFilteredPods = [];
      this.filterHiddenShows = false;
      this.filterPublicShow = false;
      this.filterTypeGroup = false;
      this.filterTypeIndividual = false;
      // this.RF();
    },
    clearAndApplyAllFilters() {
      this.clearAllFilters();
      this.selectedSubject = 'All courses';
      this.tlcMapping();
      this.applyFilters();
    },
    getModules(sessions) {
      let modules = [];
      sessions.forEach((element) => {
        if (!modules.includes(element.title_id)) {
          modules.push(element.title_id);
        }
      });
      return modules;
    },
    getPods(sessions) {
      let pods = [];
      sessions.forEach((element) => {
        if (!pods.includes(element.pod_id)) {
          pods.push(element.pod_id);
        }
      });
      return pods;
    },
    getTotalSeats(sessions) {
      let seats = {
        available: 0,
        total: 0,
        reserved: 0,
      };
      sessions.forEach((element) => {
        seats.available = seats.available + element.seats_available;
        seats.total = seats.total + element.max_seats;
        seats.reserved = seats.reserved + element.seats_reserved;
      });
      return seats;
    },
    getPod(pod_id) {
      let temp_pod = pod_id.split('-');
      return `${temp_pod[1]}`;
    },
    filterSessions() {
      let _sessions = this.getSchedulerSessions.filter(
        (act) =>
          this.selectedSubject == 'All courses' ||
          (this.tlcTitleMapping[this.selectedSubject] &&
            this.tlcTitleMapping[this.selectedSubject].has(act.title_id))
      );

      if (this.selectedActs && this.selectedActs.length > 0) {
        _sessions = _sessions.filter((act) => this.selectedActs.includes(act.title_id));
      }

      if (this.selectedPods && this.selectedPods.length > 0) {
        _sessions = _sessions.filter((pod) => this.selectedPods.includes(pod.pod_id));
      }

      if (this.hiddenShows || this.publicSHows) {
        _sessions = _sessions.filter((session) => {
          (this.hiddenShows && session.show_time_description === 'hidden show') ||
            (this.publicSHows && _sessions.show_time_description === 'public show');
        });
      }

      if (this.typeGroup || this.typeIndividual) {
        _sessions = _sessions.filter(
          (session) =>
            session.group_session === this.typeGroup || !this.group_session === this.typeIndividual
        );
      }

      this.availableFilteredSessions = _sessions;
    },

    available(session) {
      var today = moment().tz('America/Phoenix').format();
      if (moment(session.start_timestamp).isBefore(moment(today))) {
        return false;
      }
      return true;
    },
    compareSessionDateWithPodSessionDate(date) {
      var trimDate = date.substr(0, date.indexOf('T'));
      if (trimDate == this.$store.state.podSessionDate) {
        return true;
      } else {
        return false;
      }
    },
    selectedDate(date) {
      if (date) {
        this.$store.state.loader = true;
        this.$store.state.podSessionDate = this.customFormatter(date);
        this.updateValues();
      }
    },
    handleDateChanged(momentDate) {
      if (momentDate) {
        this.$store.state.loader = true;
        this.$store.state.podSessionDate = momentDate.format('YYYY-MM-DD');
        this.updateValues();
      }
    },
    customFormatter(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
    },
    checkToday(date) {
      if (date == this.convertToDate(new Date())) {
        return 'Today';
      }
      return date;
    },
    getIcon(img) {
      return require('@/assets/icons/' + img);
    },
    changeCurrentDate(day) {
      this.$store.state.loader = true;
      let temp = moment(this.$store.state.podSessionDate, 'YYYY-MM-DD').add(day, 'days');
      this.$store.state.podSessionDate = moment(temp).format('YYYY-MM-DD');
      this.updateValues();
    },
    updateValues() {
      const activeSiteId =
        this.$store.state.selectedSiteForScheduler?.site_id || this.$store.state.selected_site_id;
      let myData = {
        selected_site_id: activeSiteId,
        podSessionDate: this.$store.state.podSessionDate,
      };
      this.$store
        .dispatch('setSchedulerSessions', myData)
        .then(() => {
          this.$store.state.loader = false;
          // Refresh cross-system occupancy after sessions have settled
          this.loadCrossSystemDay(this.$store, myData.podSessionDate);
        })
        .catch(() => {
          this.$store.state.loader = false;
        });
    },
    getnextday(numOfDays) {
      let dateStr = this.$store.state.podSessionDate;
      return this.convertToDate(
        new Date(new Date(dateStr).setDate(new Date(dateStr).getDate() + numOfDays))
      );
    },
    convertToDate(str) {
      var date = new Date(str),
        mnth = ('0' + (date.getMonth() + 1)).slice(-2),
        day = ('0' + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join('-');
    },
    RF() {
      this.$store.state.appointmentsRefresh = false;
      setTimeout(() => {
        this.$store.state.appointmentsRefresh = true;
      }, 100);
    },

    getTrimTime(timestamp) {
      return moment(timestamp).format('hh:mm A');
    },
    getTrimDate(timestamp) {
      let temp = timestamp.split('T');
      return moment(temp[0]).format('ddd, MMM D, YYYY');
    },
    OpenCancelSession(num) {
      this.sessionid = num;
      this.openCancelBtn = !this.openCancelBtn;
    },
    hide() {
      this.openCancelBtn = false;
    },
    async CancelSession(session) {
      // API to cancel sesion
      await API.del(
        'proxy',
        `/${this.$store.state.selectedSiteForScheduler.site_id}/dsl/scheduler/session/${session.session_id}`
      )
        .then((response) => {
          let myData = {
            selected_site_id: this.$store.state.selected_site_id,
            podSessionDate: this.$store.state.podSessionDate,
          };
          this.$store.dispatch('setSchedulerSessions', myData);
        })
        .catch((err) => {
          this.$store.state.error = err.response.data;
          const errorModalEl = document.getElementById('error-checkin');
          if (errorModalEl) {
            const modal = Modal.getOrCreateInstance(errorModalEl);
            modal.show();
          }
        });
    },
    getCurrentWeek() {
      if (!this.isMouseDragging) {
        const podSessionDate = this.$store.state.podSessionDate;
        if (!podSessionDate) {
          return [];
        }
        const dateParts = podSessionDate.split('-');
        const year = parseInt(dateParts[0]);
        const month = parseInt(dateParts[1]) - 1;
        const dayy = parseInt(dateParts[2]);
        const today = new Date(year, month, dayy);
        const dayOfWeek = today.getDay();
        const startDate = new Date(today);
        startDate.setDate(today.getDate() - dayOfWeek);
        const currentWeek = [];

        for (let i = 0; i < 7; i++) {
          const currentDate = new Date(startDate);
          currentDate.setDate(startDate.getDate() + i);
          currentWeek.push(currentDate);
        }
        return currentWeek;
      }
      return [];
    },
    getIndexOfSelectedDate() {
      const dateParts = this.$store.state.podSessionDate.split('-');
      const year = parseInt(dateParts[0]);
      const month = parseInt(dateParts[1]) - 1;
      const dayy = parseInt(dateParts[2]);

      const today = new Date(year, month, dayy);
      let dayOfWeek = today.getDay();
      if (dayOfWeek <= 0) {
        dayOfWeek = 0;
      } else if (dayOfWeek >= 6) {
        dayOfWeek = 4;
      } else {
        dayOfWeek -= 1;
      }
      if (window.innerWidth < 768) {
        if (dayOfWeek >= 4) dayOfWeek = 3;
      }
      return dayOfWeek;
    },
    handlePanStart() {
      this.isMouseDragging = true;
    },
    handlePanEnd() {
      this.isMouseDragging = false;
    },
    setCurrentDate(day) {
      const year = day.getFullYear();
      const month = (day.getMonth() + 1).toString().padStart(2, '0');
      const dayy = day.getDate().toString().padStart(2, '0');
      const formattedDate = `${year}-${month}-${dayy}`;
      this.$store.state.podSessionDate = formattedDate;
      this.updateValues();
    },
    isDaySelected(day) {
      const currentDate = this.$store.state.podSessionDate;
      const year = day.getFullYear();
      const month = (day.getMonth() + 1).toString().padStart(2, '0');
      const dayy = day.getDate().toString().padStart(2, '0');
      const formattedDate = `${year}-${month}-${dayy}`;
      const isSelected = formattedDate === currentDate;
      return isSelected;
    },
    isToday(day) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
      const dayy = currentDate.getDate().toString().padStart(2, '0');
      const formattedDate = `${year}-${month}-${dayy}`;

      const year2 = day.getFullYear();
      const month2 = (day.getMonth() + 1).toString().padStart(2, '0');
      const dayy2 = day.getDate().toString().padStart(2, '0');
      const dayStr = `${year2}-${month2}-${dayy2}`;

      const isSelected = dayStr === formattedDate;
      return isSelected;
    },
    togglePodFilterCollapseMobile() {
      this.isPodFilterCollapsedMobile = !this.isPodFilterCollapsedMobile;
    },
    toggleShowFilterCollapseMobile() {
      this.isShowFilterCollapsedMobile = !this.isShowFilterCollapsedMobile;
    },
    toggleAudienceFilterCollapseMobile() {
      this.isAudienceFilterCollapsedMobile = !this.isAudienceFilterCollapsedMobile;
    },
    filterPodCollapseMobile() {
      return this.isPodFilterCollapsedMobile
        ? require('@/assets/icons/' + 'accordion-down-arrow.svg')
        : require('@/assets/icons/' + 'accordion-down-arrow.svg');
    },
    filterShowCollapseMobile() {
      return this.isShowFilterCollapsedMobile
        ? require('@/assets/icons/' + 'accordion-down-arrow.svg')
        : require('@/assets/icons/' + 'accordion-down-arrow.svg');
    },
    filterAudienceCollapseMobile() {
      return this.isAudienceFilterCollapsedMobile
        ? require('@/assets/icons/' + 'accordion-down-arrow.svg')
        : require('@/assets/icons/' + 'accordion-down-arrow.svg');
    },
    filterReservationCollapseMobile() {
      return this.isReservationFilterCollapsedMobile
        ? require('@/assets/icons/' + 'accordion-down-arrow.svg')
        : require('@/assets/icons/' + 'accordion-down-arrow.svg');
    },
    toggleCollapsedUserDetails(pod_id, session_id) {
      const uniqueId = pod_id + '***' + session_id;
      if (this.isCollapsedUserDetails.includes(uniqueId)) {
        this.isCollapsedUserDetails = this.isCollapsedUserDetails.filter((e) => e !== uniqueId);
      } else {
        this.isCollapsedUserDetails.push(uniqueId);
      }
    },
    getCollapsedUserDetails(pod_id, session_id) {
      const uniqueId = pod_id + '***' + session_id;
      if (this.isCollapsedUserDetails.includes(uniqueId)) {
        return require('@/assets/icons/' + 'filter-collapse-minus-mobile.svg');
      }
      return require('@/assets/icons/' + 'filter-collapse-plus-mobile.svg');
    },
    getAppliedFilters(sessions) {
      let appliedFilters =
        this.selectedFilteredPods.length +
        this.selectedFilteredActs.length +
        (this.filterHiddenShows ? 1 : 0) +
        (this.filterPublicShow ? 1 : 0) +
        (this.filterTypeGroup ? 1 : 0) +
        (this.filterTypeIndividual ? 1 : 0);
      return appliedFilters;
    },
  },
};
</script>

<style lang="scss" scoped>
.mobile-date-row {
  height: 100px;
}

.schedule-divider {
  width: 100%;
  max-width: 375px;
  height: 0;
  border: none;
  border-top: 0.5px solid #0e4f74;
  opacity: 1;
  margin: 12px auto 0;
}

@media (max-width: 767px) {
  .mobile-seats-label {
    color: #ffc627 !important;
  }

  .mobile-seats-count {
    min-width: 73px;
    text-align: center;
  }
}

.reset-button-filter {
  background: #313131 !important;
  color: #f1f1f1;
  border-radius: 8px;
  padding-right: 28px;
  padding-left: 28px;
  margin-right: 16px;
  width: 136px;
}

.dropdown-wrapper {
  position: relative;
  display: inline-block;
}

.dropdown-toggle-no-caret::after {
  display: none;
}

.moduleAct-corses {
  background: #fafafa !important;
  color: #151515 !important;
  padding: 8px 8px;
  border-radius: 4px !important;
  cursor: pointer;
  height: 38px;
}

.dropdown-options {
  position: absolute;
  background: #2c2c2c !important;
  border-radius: 4px;
  z-index: 1000;
  width: 252px !important;
}

.dropdown-options button,
.dropdown-options a {
  padding: 8px;
  cursor: pointer;
  list-style-type: none;
  margin: 0;
  text-decoration: none;
}

.dropdown-options button:hover,
.dropdown-options a:hover {
  background: #0e4f74;
}

.v-calendar-daily__scroll-area {
  background: #0e0e0e !important;
}

.hover-button {
  background: #2c2c2c !important;
  color: #fff !important;
}

.hover-button:hover {
  background: #0e4f74 !important;
  color: #fff !important;
}

.custom-dropdown {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #333;
  color: white;
}

.dropdown-options {
  position: absolute;
  background: #2c2c2c;
  border-radius: 2px;
  z-index: 1000;
  width: 252px !important;
  left: 0%;
  top: 48px;
}

.dropdown-option {
  padding: 10px;
  cursor: pointer;
}

.dropdown-option:hover {
  background-color: #555;
}

.pod-schedule-filter {
  overflow-y: scroll;
}

.moduleAct {
  background: #ecedee !important;
  color: #151515 !important;
  border-radius: 2px;
}

.schedule-bg {
  height: 209px;
  background:
    linear-gradient(0deg, #0e0e0e 1%, transparent 50%),
    url('../assets/images/pod-schedule2xBgImage.png');
  background-size: cover;
}

.session-date-selector {
  position: absolute !important;
}

.tableScroll {
  overflow-x: scroll;
  overflow-y: hidden;

  ::-webkit-scrollbar {
    display: none;
  }
}

.podSessionDate {
  background: #252525;
  padding: 7px 16px !important;
  border-radius: 20px;
}

.podSessionDate:hover {
  text-decoration: none;
}

.modal-content {
  border-right: 0.1px solid #7f7f7f;
  background-color: #0e0e0e !important;
}

.modal-dialog-slideout {
  min-height: 100%;
  margin: 0 0 0 auto;
}

.mobile-filter-content {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.modal.fade .modal-dialog.modal-dialog-slideout {
  left: -50%;
  display: flex;
  align-items: stretch;
  -webkit-box-align: stretch;
  height: 100%;
  -webkit-transition:
    opacity 0.1s linear,
    left 0.1s ease-out;
  transition:
    opacity 0.1s linear,
    left 0.1s ease-out;
}

.modal.fade.show .modal-dialog.modal-dialog-slideout {
  left: 0;
  display: flex;
  align-items: stretch;
  -webkit-box-align: stretch;
  height: 100%;
}

.modal-md {
  width: 75%;
}

.modal-backdrop {
  z-index: 990 !important;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 520px !important;
  }
}

/* ── Cross-system occupancy cards ───────────────────────────────────────── */
.cross-system-card {
  border-radius: 8px;
  border: 1px solid #3a3a3a;
  overflow: hidden;
}

.cross-system-card-inner {
  /* Diagonal stripe overlay on top of #242424 background (set inline) */
  background-image: repeating-linear-gradient(
    -45deg,
    transparent 0px,
    transparent 5px,
    rgba(255, 255, 255, 0.04) 5px,
    rgba(255, 255, 255, 0.04) 10px
  );
}
</style>

<style lang="scss">
@media (max-width: 767px) {
  .carousel__viewport {
    display: none !important;
  }
}

.text-lightt {
  color: white !important;
  text-decoration: underline;
}

.text-lightt:hover {
  color: #ffc627 !important;
}

.import-btn:hover,
.logout:hover {
  .hide-hover {
    display: none !important;
  }

  .show-hover {
    display: inline !important;
  }
}

.logout {
  .show-hover {
    display: none;
  }
}

.invite-participants {
  color: #151515;
  background: #fff !important;
  border-radius: 7px !important;
  padding: 4px 14px 10px 14px;
}

.import-btn {
  color: #ffc627;

  &:hover {
    color: #252525;
    background: #ffc627 !important;
  }

  .show-hover {
    display: none;
  }
}

.tableScroll::-webkit-scrollbar {
  display: none;
}

.table-header {
  background: #ffffff1a;
}

.table-header th {
  color: white;
}

.yellow-checkbox {
  background: #ffc627;
  height: 17px;
  width: 17px;
  margin: 2px;
  border-radius: 3px;
}

.green-checkbox {
  background: #78be20;
  height: 17px;
  width: 17px;
  margin: 2px;
  border-radius: 3px;
}

.grey-checkbox {
  background: #ffffff1a;
  height: 17px;
  width: 17px;
  margin: 2px;
  border-radius: 3px;
}

.wheelChair {
  margin: 2px;

  img {
    height: 17px;
    width: 17px;
  }
}

.btn-gold {
  color: #ffc627;
  border: 1px solid #ffc627;
  border-radius: 4px;
}

.btn-white {
  color: #fff;
  border: 1px solid #fff;
  border-radius: 4px;
}

.no-sessions {
  height: 100vh;
  text-align: center;
}

.caousel-date {
  width: 150px;
}

@media only screen and (max-width: 1200px) {
  .caousel-date {
    width: 120px;
  }
}

.vdp-datepicker__calendar {
  .cell.highlighted {
    background: #707070 !important;
    font-weight: bold;
  }

  .cell.selected {
    background: #ffc627 !important;
    color: #151515 !important;
    font-weight: bold !important;
  }
}

@media only screen and (max-width: 767px) {
  .schedule-bg {
    height: auto !important;
    background: none !important;
    background-image: none !important;
    background-size: unset !important;
    padding: 16px 0;
    overflow: visible;
    z-index: 10;
    position: relative;
  }

  #pod-schedule {
    margin-left: 0;
  }

  .caousel-date {
    width: 90px;
  }

  .grey-checkbox,
  .yellow-checkbox {
    width: 8px;
    height: 8px;
  }

  .vdp-datepicker__calendar {
    left: 0px;
  }
}

@media only screen and (max-width: 991.98px) {
  .yellow-checkbox {
    display: none;
  }

  .grey-checkbox {
    display: none;
  }

  .wheelChair {
    display: none;
  }
}

.op-40 {
  opacity: 0.4;
}

input.checkbox {
  transform: scale(1.2);
}

.scroll-to-acts {
  position: fixed;
  top: 85%;
  background: gray;
  border-radius: 50%;
  padding: 10px 12px;
  left: 90%;
  z-index: 99;
}

.btn-icon {
  transform: rotate(270deg);
  margin-top: 2px;
}

.dropdown-menu {
  background: transparent !important;
  border: none !important;
  color: white !important;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.border-layout-filter {
  border: 1px solid;
  border-radius: 8px;
  border-color: #d0d0d05e;
}

.border-layout {
  border: 1px solid;
  border-radius: 8px;
  border-color: #424242;
}

.btn-disabled {
  opacity: 0.5;
  cursor: auto;
}
</style>
<style>
/* Dropdown styles */
#shows-dropdown {
  /* Custom positioning disabled for now */
  /* transform: translate3d(418px, 51px, 0px) !important; */
}

/* The container */
.check-container {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 12px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.check-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: #eee;
  border-radius: 4px;
}

.checkmark-mobile {
  position: absolute;
  top: 1px !important;
  left: 0;
  height: 20px;
  width: 20px;
  min-width: 20px;
  background: transparent;
  border: 1.5px solid #d0d0d0;
  border-radius: 3px;
}

/* On mouse-over, add a grey background color */
.check-container:hover input ~ .checkmark {
  background-color: #ccc;
}

.check-container:hover input ~ .checkmark-mobile {
  background-color: rgba(255, 255, 255, 0.1);
}

/* When the checkbox is checked, add a blue background */
.check-container input:checked ~ .checkmark {
  background-color: #ffc627;
  border-radius: 4px;
}

.check-container input:checked ~ .checkmark-mobile {
  background-color: #2196f3;
  border-color: #2196f3;
  border-radius: 3px;
}

.check-container input:checked ~ .checkmark-mobile::after {
  content: '';
  width: 5px;
  height: 10px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  position: absolute;
  top: 2px;
  left: 6px;
  display: block;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.check-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.check-container .checkmark:after {
  left: 7px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid #000;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
}

.check-btn {
  background-color: #ffffff !important;
  border-radius: 7px !important;
  box-shadow: 0px 3px 6px #00000081 !important;
}

.import-btn {
  padding: 12px 29px !important;
  border-radius: 30px !important;
}

.pod-num {
  background: #0e4f74;
  color: #ffffff;
  border-radius: 50%;
  padding: 3px 4px;
  font-size: 14px;
}

a:hover {
  text-decoration: none !important;
}

.button-carousel-mobile {
  width: 50px !important;
  height: 55px !important;
  background-color: #272727 !important;
  color: #5b5b5b !important;
  border-radius: 5px !important;
}

.month-carousel-mobile {
  font-size: 9px;
}

.date-carousel-mobile {
  font-size: 16px;
  font-weight: bold;
  line-height: 18px;
}

.selected-button-carousel-mobile {
  background-color: #ffc627 !important;
  color: #151515 !important;
  border: 0.5px solid #ffc627 !important;
  border-radius: 5px !important;
}

.today-button-carousel-mobile {
  background-color: #313131 !important;
  color: #d0d0d0 !important;
  border: 0.5px solid #ffffff !important;
  border-radius: 5px !important;
}

/* Calendar button and icon were on different position */
.session-date-selector-mobile input {
  margin: 0 !important;
  padding: 0 !important;
}

.session-date-selector input {
  margin: 0 !important;
  padding: 0 !important;
}

.filter-button-mobile {
  height: 38px;
  padding: 0 12px;
  background-color: #282828 !important;
  color: #ffffff !important;
  border: 0.3px solid #d0d0d026 !important;
  border-radius: 5px !important;
}

.filter-header-mobile {
  font-size: 18px;
  color: #ffc627;
}

.apply-filter-button-mobile {
  width: 136px !important;
  height: 42px !important;
  background-color: #ffc627 !important;
  color: #000;
  border: 0.5px solid #ffc627 !important;
  border-radius: 8px !important;
}

.clear-filter-button-mobile {
  width: 136px !important;
  height: 42px !important;
  background-color: #2c2c2c !important;
  color: #ffffff;
  border: none !important;
  border-radius: 8px !important;
}

@media only screen and (max-width: 767px) {
  .clear-filter-button-mobile,
  .apply-filter-button-mobile {
    height: 35px !important;
    width: 106px !important;
  }

  label.check-container {
    font-size: 14px;
  }
}

.clear-all-filters-button {
  height: 42px !important;
  background-color: #ffc627 !important;
  color: #000;
  border: 0.5px solid #ffc627 !important;
  border-radius: 8px !important;
  white-space: nowrap;
}

@media only screen and (max-width: 767px) {
  .clear-all-filters-button {
    height: 35px !important;
  }
}

.filter-category-mobile {
  color: #ffffff !important;
  font-weight: bold !important;
}

.accordion-heading-button {
  border: none !important;
  border-radius: 0px !important;
  color: #ffffff;
  width: 100%;
}

.session-header-wrap {
  position: relative;
}

/* Sits in the header's top-right, beside the accordion chevron. The extra right
   padding on the header button below is what makes room for it. */
.session-actions {
  position: absolute;
  top: 36px;
  right: 32px;
  z-index: 5;
}

.accordion-heading-button-desktop {
  /* Right padding leaves a 30px gap + the 30px actions button clear of the chevron. */
  padding: 32px 74px 26px 32px;
  border: none !important;
  border-radius: 0px !important;
  color: #ffffff;
  width: 100%;
  height: 156px;
}

.accordion-heading-button:not(.collapsed) {
  background-color: #132d3b !important;
}

.accordion-heading-button:not(.collapsed) .rotate-icon {
  transform: rotate(180deg);
}

.accordion-heading-button-desktop:not(.collapsed) .rotate-icon {
  transform: rotate(180deg);
}

.accicon {
  float: right;
}

.collapse-user-details-header {
  width: 100% !important;
  border: none !important;
  color: #fff;
}

.autovip-checkin:hover {
  background-color: #5b5b5b !important;
}

.autovip-checkin {
  background-color: #313131 !important;
  color: #ffffff !important;
  padding: 0.5rem 0.7rem !important;
  border: 1px solid #313131 !important;
  border-radius: 5px !important;
}

.autovip-checkin-mobile {
  background-color: #3a373a !important;
  color: #ffffff !important;
  padding: 4px 8px !important;
  margin-left: 10px !important;
  border: 1px solid #151515 !important;
  border-radius: 5px !important;
}

.podSession-subjects {
  color: #fafafa !important;
  background: #2c2c2c !important;
  padding: 4px 4px 4px 4px;
  height: 38px;
  border-radius: 4px;
}

.podSession {
  color: #2c2c2c !important;
  background: #ffff !important;
  padding: 4px 8px 4px 4px;
  border-radius: 2px;
}

/* Filter Modal Custom Styles */
.filter-section {
  border-bottom: 0.5px solid #ffffff66;
}

.filter-header {
  color: #fff;
  font-weight: 600;
  font-size: 12px;
}

.mobile-filter-content {
  padding: 0;
}

.mobile-filter-section {
  border-bottom: 0.5px solid #93751f;
}

.mobile-filter-header {
  color: #ffffff;
  background-color: #0e0e0e;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.2s;
}

.filter-chevron {
  transition: transform 0.2s ease;
}

.filter-chevron--open {
  transform: rotate(180deg);
}

.mobile-filter-header:hover {
  background-color: #1f1f1f;
}
</style>
